var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3151 2.89773C11.2687 2.89773 12.0417 3.67614 12.0417 4.63636C12.0417 5.59659 11.2687 6.375 10.3151 6.375C9.36159 6.375 8.58858 5.59659 8.58858 4.63636C8.58858 3.67614 9.36159 2.89773 10.3151 2.89773ZM5.13546 0C6.40686 0 7.43754 1.03789 7.43754 2.31818C7.43754 3.59848 6.40686 4.63636 5.13546 4.63636C3.86405 4.63636 2.83337 3.59848 2.83337 2.31818C2.83337 1.03789 3.86405 0 5.13546 0Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3898 6.90686L10.3228 6.90621C12.3639 6.90621 14.0409 7.97219 14.1658 10.2531C14.1708 10.344 14.1658 10.625 13.8455 10.625H11.5694C11.5694 9.22997 11.1305 7.94262 10.3898 6.90686ZM5.30267 5.66663C8.12884 5.66663 10.4508 7.08793 10.6238 10.1291C10.6307 10.2503 10.6238 10.625 10.1803 10.625H0.429428C0.281393 10.625 -0.0120781 10.2898 0.000384675 10.1286C0.22918 7.17056 2.51571 5.66663 5.30267 5.66663Z",
    fill: "#343A40"
  })));
};
export default SvgPeople;